import { Component, OnInit } from '@angular/core';
import { ScheduleService } from 'src/app/shared/schedule.service';
import { MessageService } from 'src/app/shared/message.service';
import * as moment from 'moment';
import { PermissionsService } from 'src/app/shared/permissions.service';
import 'signalR';
import { Router, NavigationStart } from '@angular/router';
import { SignalRService } from 'src/app/shared/signal-r.service';
//import { environment } from 'src/environments/environment';
import { AppConfig } from 'src/app/app.config';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { AuthenticationService } from 'src/app/core/authentication/shared/authentication.service';

declare const $: any;

@Component({
  selector: 'app-admin-schedule',
  templateUrl: './admin-schedule.component.html',
  styleUrls: ['./admin-schedule.component.css']
})
export class AdminScheduleComponent implements OnInit {
  private config = AppConfig.settings;

  confirmationDialogRef: MatDialogRef<ConfirmationDialogComponent>;

  priceManagementHub;
  schedule: any = {};
  purgeOlderLogActionsDay = 'Day';

  isWindowPanelOpen = true;
  isTaskPanelOpen = true;
  isOnDemandPanelOpen = true;

  isServerMaintenanceWindowOpen;
  isPreviewPricingWindowOpen;
  //isMeatAndProducePreviewPricingWindowOpen;
  isMeatPreviewPricingWindowOpen;
  isProducePreviewPricingWindowOpen;
  isStoreItemPriceChangesWindowOpen;
  // isMeatAndProduceStoreItemPriceChangesWindowOpen;
  isMeatStoreItemPriceChangesWindowOpen;
  isProduceStoreItemPriceChangesWindowOpen;
  hubsSubscription;
  routerSubscription;
  scheduleChangeSubscription;
  signalRTimeout;
  permissions: any = {};
  pricingRulesMessage = '';
  myUser;

  links = [
    'All',
    'Daily',
    'Weekly',
    'Yearly'
  ]

  activeLink = this.links[0];

  daysOfWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]

  constructor(
    private _scheduleService: ScheduleService,
    private _authenticationService: AuthenticationService,
    private _signalRService: SignalRService,
    private _messageService: MessageService,
    private _dialog: MatDialog, 
    private _permissionsService: PermissionsService,
    private _router: Router,
  ) { }

  ngOnInit() {
    if (this.config.logInits) console.log('schedule init');
    this.permissions = this._permissionsService.getPermissions();
    this.myUser = this._authenticationService.getMyUser();
    this.getSchedule();
  }

  ngAfterContentInit(){
    var self = this;
      // subscribe to signalR hubs loading
      // this.hubsSubscription = this._notificationWindowService.areHubsLoaded$
      // .subscribe(
      //   (data) => {
      //     if (data) self.initSignalR();
      //   }
      // );
    
    // subscribe to route changes
    // https://stackoverflow.com/questions/34444822/angular2-watch-for-route-change
    this.routerSubscription = this._router.events.subscribe((event:any) => {
      //console.log(event);
      if (event instanceof NavigationStart) {
        //console.log(event.url);
        //$.connection.hub.stop();
      }
    });

    this.scheduleChangeSubscription = this._signalRService.scheduleChange$
      .subscribe(
        (data) => {
          if (data) self.getSchedule();
        }
      );
  }

  ngOnDestroy() {
    //this.hubsSubscription.unsubscribe();
    this.routerSubscription.unsubscribe();
    this.scheduleChangeSubscription.unsubscribe();
    clearTimeout(this.signalRTimeout);
  }

  getSchedule(){
    this._scheduleService.getSchedule()
      .subscribe(
        (data) => {
          this.schedule = data;
          this.isScheduleWindowOpen('ServerMaintenanceWindow');
          this.isScheduleWindowOpen('PreviewPricingWindow');
          //this.isScheduleWindowOpen('MeatAndProducePreviewPricingWindow');
          this.isScheduleWindowOpen('MeatPreviewPricingWindow');
          this.isScheduleWindowOpen('ProducePreviewPricingWindow');
          this.isScheduleWindowOpen('StoreItemPriceChangesWindow');
          // this.isScheduleWindowOpen('MeatAndProduceStoreItemPriceChangesWindow');
          this.isScheduleWindowOpen('MeatStoreItemPriceChangesWindow');
          this.isScheduleWindowOpen('ProduceStoreItemPriceChangesWindow');
          this.initSchedule();
        },
        (response) => {
          this._messageService.onFailure('Failed to get schedule.', response);
        }
      )
  }

  onTabClick(link){
    this.activeLink = link;
    //if all are closed when switching tabs, open all so the tab change shows change
    if (!this.isWindowPanelOpen && !this.isTaskPanelOpen && !this.isOnDemandPanelOpen){
      this.isWindowPanelOpen = true;
      this.isTaskPanelOpen = true;
      this.isOnDemandPanelOpen = true;
    }
  }

  isScheduleWindowOpen(scheduleWindowAsString){
    this._scheduleService.isScheduleWindowOpen(scheduleWindowAsString)
      .subscribe(
        (data: any) => {
          //console.log(scheduleWindowAsString + ':' + data.value);
          var name = 'is' + scheduleWindowAsString + 'Open';
          this[name] = data.value;
        },
        (response) => {
          this._messageService.onFailure('Failed to determine if "' + scheduleWindowAsString + '" is open.', response);
        }
      )
  }

  invokePricingRulesProcess = function () {
    //Users with hasReadOnlyRestriction set to true should not even be allowed to invoke this action because it is hidden or disabled in the UI.
    //This is for extra protection. The back end will also be protected.
    if (this.myUser.hasReadOnlyRestriction){
      this._messageService.alertReadOnlyRestriction();
      return;
    }

    this.confirmationDialogRef = this._dialog.open(ConfirmationDialogComponent, {
      disableClose: false,
      //width: '600px',
      data: {
        title: 'Important!',
        message: 'Are you sure you want to proceed with invoking the Pricing Rules process?',
        confirmText: 'Yes, proceed',
        cancelText: 'No, cancel this action!'
      }
    });
    this.confirmationDialogRef.afterClosed().subscribe(result => {
      if(result) {

        this.pricingRulesMessage = 'Request Sent ' + moment().format('M/D/YYYY, h:mm:ss a');
        this._scheduleService.setProcessPricingRulesToNow()
          .subscribe(
            (data: any) => {
              this._messageService.onSuccess("'Process Pricing Rules' has been invoked.");
            },
            (response) => {
              this.pricingRulesMessage = 'Request Failed.';
              this._messageService.onFailure("Failed to invoke 'Process Pricing Rules.'", response);
            }
          )

      }
      this.confirmationDialogRef = null;
    });

  };

  initSchedule() {
    this.schedule.serverMaintenanceWindowOpensTimeOfDayView = this.getTimeString(this.schedule.serverMaintenanceWindowOpens);
    this.schedule.serverMaintenanceWindowClosesTimeOfDayView = this.getTimeString(this.schedule.serverMaintenanceWindowCloses);

    this.schedule.previewPricingWindowOpensTimeOfDayView = this.getTimeString(this.schedule.previewPricingWindowOpens);
    this.schedule.previewPricingWindowClosesTimeOfDayView = this.getTimeString(this.schedule.previewPricingWindowCloses);

    // this.schedule.meatAndProducePreviewPricingWindowOpensTimeOfDayView = this.getTimeString(this.schedule.meatAndProducePreviewPricingWindowOpens);
    // this.schedule.meatAndProducePreviewPricingWindowClosesTimeOfDayView = this.getTimeString(this.schedule.meatAndProducePreviewPricingWindowCloses);

    this.schedule.meatPreviewPricingWindowOpensTimeOfDayView = this.getTimeString(this.schedule.meatPreviewPricingWindowOpens);
    this.schedule.meatPreviewPricingWindowClosesTimeOfDayView = this.getTimeString(this.schedule.meatPreviewPricingWindowCloses);

    this.schedule.producePreviewPricingWindowOpensTimeOfDayView = this.getTimeString(this.schedule.producePreviewPricingWindowOpens);
    this.schedule.producePreviewPricingWindowClosesTimeOfDayView = this.getTimeString(this.schedule.producePreviewPricingWindowCloses);

    this.schedule.storeItemPriceChangesWindowOpensTimeOfDayView = this.getTimeString(this.schedule.storeItemPriceChangesWindowOpens);
    this.schedule.storeItemPriceChangesWindowClosesTimeOfDayView = this.getTimeString(this.schedule.storeItemPriceChangesWindowCloses);

    // this.schedule.meatAndProduceStoreItemPriceChangesWindowOpensTimeOfDayView = this.getTimeString(this.schedule.meatAndProduceStoreItemPriceChangesWindowOpens);
    // this.schedule.meatAndProduceStoreItemPriceChangesWindowClosesTimeOfDayView = this.getTimeString(this.schedule.meatAndProduceStoreItemPriceChangesWindowCloses);

    this.schedule.meatStoreItemPriceChangesWindowOpensTimeOfDayView = this.getTimeString(this.schedule.meatStoreItemPriceChangesWindowOpens);
    this.schedule.meatStoreItemPriceChangesWindowClosesTimeOfDayView = this.getTimeString(this.schedule.meatStoreItemPriceChangesWindowCloses);

    this.schedule.produceStoreItemPriceChangesWindowOpensTimeOfDayView = this.getTimeString(this.schedule.produceStoreItemPriceChangesWindowOpens);
    this.schedule.produceStoreItemPriceChangesWindowClosesTimeOfDayView = this.getTimeString(this.schedule.produceStoreItemPriceChangesWindowCloses);

    this.schedule.nowChangesLockoutWindowOpensTimeOfDayView = this.getTimeString(this.schedule.nowChangesLockoutWindowOpens);
    this.schedule.nowChangesLockoutWindowClosesTimeOfDayView = this.getTimeString(this.schedule.nowChangesLockoutWindowCloses);


    this.schedule.purgeOldLogActionsTimeOfDayView = this.getTimeString(this.schedule.purgeOldLogActions);
    this.schedule.purgeOldMessagesTimeOfDayView = this.getTimeString(this.schedule.purgeOldMessages);
    this.schedule.purgeOldAdItemsTimeOfDayView = this.getTimeString(this.schedule.purgeOldAdItems);
    this.schedule.purgeOldStoreItemPriceChangesTimeOfDayView = this.getTimeString(this.schedule.purgeOldStoreItemPriceChanges);
    this.schedule.purgeOldStoreItemCostChangesTimeOfDayView = this.getTimeString(this.schedule.purgeOldStoreItemCostChanges);
    this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChangesTimeOfDayView = this.getTimeString(this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChanges);
    this.schedule.updateStoreItemsFromPreviewStoreItemsTimeOfDayView = this.getTimeString(this.schedule.updateStoreItemsFromPreviewStoreItems);
    this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsTimeOfDayView = this.getTimeString(this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItems);
    this.schedule.deleteMeatAndProducePreviewStoreItemsTimeOfDayView = this.getTimeString(this.schedule.deleteMeatAndProducePreviewStoreItems);
    this.schedule.incrementStoreItemsWeeksInStoreTimeOfDayView = this.getTimeString(this.schedule.incrementStoreItemsWeeksInStore);
    this.schedule.resetStoreItemsMovementAndWeeksInStoreTimeOfDayView = this.getTimeString(this.schedule.resetStoreItemsMovementAndWeeksInStore);

    this.schedule.serverMaintenanceWindowOpensNext = moment(this.schedule.serverMaintenanceWindowOpens).format('M/D/YYYY');
    this.schedule.serverMaintenanceWindowClosesNext = moment(this.schedule.serverMaintenanceWindowCloses).format('M/D/YYYY');

    this.schedule.previewPricingWindowOpensNext = moment(this.schedule.previewPricingWindowOpens).format('M/D/YYYY');
    this.schedule.previewPricingWindowClosesNext = moment(this.schedule.previewPricingWindowCloses).format('M/D/YYYY');

    // this.schedule.meatAndProducePreviewPricingWindowOpensNext = moment(this.schedule.meatAndProducePreviewPricingWindowOpens).format('M/D/YYYY');
    // this.schedule.meatAndProducePreviewPricingWindowClosesNext = moment(this.schedule.meatAndProducePreviewPricingWindowCloses).format('M/D/YYYY');

    this.schedule.meatPreviewPricingWindowOpensNext = moment(this.schedule.meatPreviewPricingWindowOpens).format('M/D/YYYY');
    this.schedule.meatPreviewPricingWindowClosesNext = moment(this.schedule.meatPreviewPricingWindowCloses).format('M/D/YYYY');

    this.schedule.producePreviewPricingWindowOpensNext = moment(this.schedule.producePreviewPricingWindowOpens).format('M/D/YYYY');
    this.schedule.producePreviewPricingWindowClosesNext = moment(this.schedule.producePreviewPricingWindowCloses).format('M/D/YYYY');

    this.schedule.storeItemPriceChangesWindowOpensNext = moment(this.schedule.storeItemPriceChangesWindowOpens).format('M/D/YYYY');
    this.schedule.storeItemPriceChangesWindowClosesNext = moment(this.schedule.storeItemPriceChangesWindowCloses).format('M/D/YYYY');

    // this.schedule.meatAndProduceStoreItemPriceChangesWindowOpensNext = moment(this.schedule.meatAndProduceStoreItemPriceChangesWindowOpens).format('M/D/YYYY');
    // this.schedule.meatAndProduceStoreItemPriceChangesWindowClosesNext = moment(this.schedule.meatAndProduceStoreItemPriceChangesWindowCloses).format('M/D/YYYY');

    this.schedule.meatStoreItemPriceChangesWindowOpensNext = moment(this.schedule.meatStoreItemPriceChangesWindowOpens).format('M/D/YYYY');
    this.schedule.meatStoreItemPriceChangesWindowClosesNext = moment(this.schedule.meatStoreItemPriceChangesWindowCloses).format('M/D/YYYY');

    this.schedule.produceStoreItemPriceChangesWindowOpensNext = moment(this.schedule.produceStoreItemPriceChangesWindowOpens).format('M/D/YYYY');
    this.schedule.produceStoreItemPriceChangesWindowClosesNext = moment(this.schedule.produceStoreItemPriceChangesWindowCloses).format('M/D/YYYY');

    this.schedule.nowChangesLockoutWindowOpensNext = moment(this.schedule.nowChangesLockoutWindowOpens).format('M/D/YYYY');
    this.schedule.nowChangesLockoutWindowClosesNext = moment(this.schedule.nowChangesLockoutWindowCloses).format('M/D/YYYY');

    this.schedule.purgeOldLogActionsNext = moment(this.schedule.purgeOldLogActions).format('M/D/YYYY');
    this.schedule.purgeOldMessagesNext = moment(this.schedule.purgeOldMessages).format('M/D/YYYY');
    this.schedule.purgeOldAdItemsNext = moment(this.schedule.purgeOldAdItems).format('M/D/YYYY');
    this.schedule.purgeOldStoreItemPriceChangesNext = moment(this.schedule.purgeOldStoreItemPriceChanges).format('M/D/YYYY');
    this.schedule.purgeOldStoreItemCostChangesNext = moment(this.schedule.purgeOldStoreItemCostChanges).format('M/D/YYYY');
    this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChangesNext = moment(this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChanges).format('M/D/YYYY');
    this.schedule.updateStoreItemsFromPreviewStoreItemsNext = moment(this.schedule.updateStoreItemsFromPreviewStoreItems).format('M/D/YYYY');
    this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsNext = moment(this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItems).format('M/D/YYYY');
    this.schedule.deleteMeatAndProducePreviewStoreItemsNext = moment(this.schedule.deleteMeatAndProducePreviewStoreItems).format('M/D/YYYY');
    this.schedule.incrementStoreItemsWeeksInStoreNext = moment(this.schedule.incrementStoreItemsWeeksInStore).format('M/D/YYYY');
    this.schedule.resetStoreItemsMovementAndWeeksInStoreNext = moment(this.schedule.resetStoreItemsMovementAndWeeksInStore).format('M/D/YYYY');

    this.schedule.deleteMeatAndProducePreviewStoreItemsLastStarted = this.schedule.deleteMeatAndProducePreviewStoreItemsLastStarted != null ? moment(this.schedule.deleteMeatAndProducePreviewStoreItemsLastStarted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.incrementStoreItemsWeeksInStoreLastStarted = this.schedule.incrementStoreItemsWeeksInStoreLastStarted != null ? moment(this.schedule.incrementStoreItemsWeeksInStoreLastStarted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.purgeOldLogActionsLastStarted = this.schedule.purgeOldLogActionsLastStarted != null ? moment(this.schedule.purgeOldLogActionsLastStarted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.purgeOldMessagesLastStarted = this.schedule.purgeOldMessagesLastStarted != null ? moment(this.schedule.purgeOldMessagesLastStarted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.purgeOldAdItemsLastStarted = this.schedule.purgeOldAdItemsLastStarted != null ? moment(this.schedule.purgeOldAdItemsLastStarted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.purgeOldStoreItemPriceChangesLastStarted = this.schedule.purgeOldStoreItemPriceChangesLastStarted != null ? moment(this.schedule.purgeOldStoreItemPriceChangesLastStarted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.purgeOldStoreItemCostChangesLastStarted = this.schedule.purgeOldStoreItemCostChangesLastStarted != null ? moment(this.schedule.purgeOldStoreItemCostChangesLastStarted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChangesLastStarted = this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChangesLastStarted != null ? moment(this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChangesLastStarted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.resetStoreItemsMovementAndWeeksInStoreLastStarted = this.schedule.resetStoreItemsMovementAndWeeksInStoreLastStarted != null ? moment(this.schedule.resetStoreItemsMovementAndWeeksInStoreLastStarted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsLastStarted = this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsLastStarted != null ? moment(this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsLastStarted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.updateStoreItemsFromPreviewStoreItemsLastStarted = this.schedule.updateStoreItemsFromPreviewStoreItemsLastStarted != null ? moment(this.schedule.updateStoreItemsFromPreviewStoreItemsLastStarted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.processPricingRulesLastStarted = this.schedule.processPricingRulesLastStarted != null ? moment(this.schedule.processPricingRulesLastStarted).format('M/D/YYYY, h:mm:ss a') : 'N/A';

    this.schedule.deleteMeatAndProducePreviewStoreItemsLastCompleted = this.schedule.deleteMeatAndProducePreviewStoreItemsLastCompleted != null ? moment(this.schedule.deleteMeatAndProducePreviewStoreItemsLastCompleted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.incrementStoreItemsWeeksInStoreLastCompleted = this.schedule.incrementStoreItemsWeeksInStoreLastCompleted != null ? moment(this.schedule.incrementStoreItemsWeeksInStoreLastCompleted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.purgeOldLogActionsLastCompleted = this.schedule.purgeOldLogActionsLastCompleted != null ? moment(this.schedule.purgeOldLogActionsLastCompleted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.purgeOldMessagesLastCompleted = this.schedule.purgeOldMessagesLastCompleted != null ? moment(this.schedule.purgeOldMessagesLastCompleted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.purgeOldAdItemsLastCompleted = this.schedule.purgeOldAdItemsLastCompleted != null ? moment(this.schedule.purgeOldAdItemsLastCompleted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.purgeOldStoreItemPriceChangesLastCompleted = this.schedule.purgeOldStoreItemPriceChangesLastCompleted != null ? moment(this.schedule.purgeOldStoreItemPriceChangesLastCompleted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.purgeOldStoreItemCostChangesLastCompleted = this.schedule.purgeOldStoreItemCostChangesLastCompleted != null ? moment(this.schedule.purgeOldStoreItemCostChangesLastCompleted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChangesLastCompleted = this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChangesLastCompleted != null ? moment(this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChangesLastCompleted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.resetStoreItemsMovementAndWeeksInStoreLastCompleted = this.schedule.resetStoreItemsMovementAndWeeksInStoreLastCompleted != null ? moment(this.schedule.resetStoreItemsMovementAndWeeksInStoreLastCompleted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsLastCompleted = this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsLastCompleted != null ? moment(this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsLastCompleted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.updateStoreItemsFromPreviewStoreItemsLastCompleted = this.schedule.updateStoreItemsFromPreviewStoreItemsLastCompleted != null ? moment(this.schedule.updateStoreItemsFromPreviewStoreItemsLastCompleted).format('M/D/YYYY, h:mm:ss a') : 'N/A';
    this.schedule.processPricingRulesLastCompleted = this.schedule.processPricingRulesLastCompleted != null ? moment(this.schedule.processPricingRulesLastCompleted).format('M/D/YYYY, h:mm:ss a') : 'N/A';

    // Uncomment the following to test these
    // this.schedule.deleteMeatAndProducePreviewStoreItemsLastExecutionSuccessful = true;
    // this.schedule.incrementStoreItemsWeeksInStoreLastExecutionSuccessful = true;
    // this.schedule.processPricingRulesLastExecutionSuccessful = true;
    // this.schedule.purgeOldLogActionsLastExecutionSuccessful = true;
    // this.schedule.purgeOldMessagesLastExecutionSuccessful = null;
    // this.schedule.purgeOldAdItemsLastExecutionSuccessful = null;
    // this.schedule.purgeOldStoreItemPriceChangesLastExecutionSuccessful = true;
    // this.schedule.purgeOldStoreItemCostChangesLastExecutionSuccessful = false;
    // this.schedule.resetStoreItemsMovementAndWeeksInStoreLastExecutionSuccessful = false;
    // this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsLastExecutionSuccessful = false;
    // this.schedule.updateStoreItemsFromPreviewStoreItemsLastExecutionSuccessful = false;
    // this.schedule.processPricingRulesLastExecutionSuccessful = false;

    // Uncomment to test in process overlay
    // this.schedule.processPricingRulesExecutionRequested = '2019-03-01T13:03:05.17';
    // this.schedule.resetStoreItemsMovementAndWeeksInStoreExecutionRequested = '2019-03-01T13:03:05.17';
    // this.schedule.incrementStoreItemsWeeksInStoreExecutionRequested = '2019-03-01T13:03:05.17';
    // this.schedule.deleteMeatAndProducePreviewStoreItemsExecutionRequested = '2019-03-01T13:03:05.17';
    // this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsExecutionRequested = '2019-03-01T13:03:05.17';
    // this.schedule.updateStoreItemsFromPreviewStoreItemsExecutionRequested = '2019-03-01T13:03:05.17';
    // this.schedule.purgeOldStoreItemCostChangesExecutionRequested = '2019-03-01T13:03:05.17';
    // this.schedule.purgeOldStoreItemPriceChangesExecutionRequested = '2019-03-01T13:03:05.17';
    // this.schedule.purgeOldAdItemsExecutionRequested = '2019-03-01T13:03:05.17';
    // this.schedule.purgeOldMessagesExecutionRequested = '2019-03-01T13:03:05.17';
    // this.schedule.purgeOldLogActionsExecutionRequested = '2019-03-01T13:03:05.17';

  }

  formatDate(d) {
    return d ? moment(d).format('M/D/YYYY, h:mm:ss a') : null;
  };

  getTimeString(date){
    date = new Date(date);
    var hours = date.getHours();
    if (hours < 10) hours = '0' + hours;
    var minutes = date.getMinutes();
    if (minutes < 10) minutes = '0' + minutes;
    return hours + ':' + minutes;
  }

  updateSchedule() {
    //Users with hasReadOnlyRestriction set to true should not even be allowed to invoke this action because it is hidden or disabled in the UI.
    //This is for extra protection. The back end will also be protected.
    if (this.myUser.hasReadOnlyRestriction){
      this._messageService.alertReadOnlyRestriction();
      return;
    }

    if (this.schedule.logActionsTimeToLiveInDays == '' || this.schedule.logActionsTimeToLiveInDays < 1) this.schedule.logActionsTimeToLiveInDays = 1;

    this.schedule.previewPricingWindowOpensTimeOfDay = this.schedule.previewPricingWindowOpensTimeOfDayView != null ? this.schedule.previewPricingWindowOpensTimeOfDayView : '00:00';
    this.schedule.previewPricingWindowClosesTimeOfDay = this.schedule.previewPricingWindowClosesTimeOfDayView != null ? this.schedule.previewPricingWindowClosesTimeOfDayView : '00:00';

    // this.schedule.meatAndProducePreviewPricingWindowOpensTimeOfDay = this.schedule.meatAndProducePreviewPricingWindowOpensTimeOfDayView != null ? this.schedule.meatAndProducePreviewPricingWindowOpensTimeOfDayView : '00:00';
    // this.schedule.meatAndProducePreviewPricingWindowClosesTimeOfDay = this.schedule.meatAndProducePreviewPricingWindowClosesTimeOfDayView != null ? this.schedule.meatAndProducePreviewPricingWindowClosesTimeOfDayView : '00:00';

    this.schedule.meatPreviewPricingWindowOpensTimeOfDay = this.schedule.meatPreviewPricingWindowOpensTimeOfDayView != null ? this.schedule.meatPreviewPricingWindowOpensTimeOfDayView : '00:00';
    this.schedule.meatPreviewPricingWindowClosesTimeOfDay = this.schedule.meatPreviewPricingWindowClosesTimeOfDayView != null ? this.schedule.meatPreviewPricingWindowClosesTimeOfDayView : '00:00';

    this.schedule.producePreviewPricingWindowOpensTimeOfDay = this.schedule.producePreviewPricingWindowOpensTimeOfDayView != null ? this.schedule.producePreviewPricingWindowOpensTimeOfDayView : '00:00';
    this.schedule.producePreviewPricingWindowClosesTimeOfDay = this.schedule.producePreviewPricingWindowClosesTimeOfDayView != null ? this.schedule.producePreviewPricingWindowClosesTimeOfDayView : '00:00';

    this.schedule.storeItemPriceChangesWindowOpensTimeOfDay = this.schedule.storeItemPriceChangesWindowOpensTimeOfDayView != null ? this.schedule.storeItemPriceChangesWindowOpensTimeOfDayView : '00:00';
    this.schedule.storeItemPriceChangesWindowClosesTimeOfDay = this.schedule.storeItemPriceChangesWindowClosesTimeOfDayView != null ? this.schedule.storeItemPriceChangesWindowClosesTimeOfDayView : '00:00';

    // this.schedule.meatAndProduceStoreItemPriceChangesWindowOpensTimeOfDay = this.schedule.meatAndProduceStoreItemPriceChangesWindowOpensTimeOfDayView != null ? this.schedule.meatAndProduceStoreItemPriceChangesWindowOpensTimeOfDayView : '00:00';
    // this.schedule.meatAndProduceStoreItemPriceChangesWindowClosesTimeOfDay = this.schedule.meatAndProduceStoreItemPriceChangesWindowClosesTimeOfDayView != null ? this.schedule.meatAndProduceStoreItemPriceChangesWindowClosesTimeOfDayView : '00:00';

    this.schedule.meatStoreItemPriceChangesWindowOpensTimeOfDay = this.schedule.meatStoreItemPriceChangesWindowOpensTimeOfDayView != null ? this.schedule.meatStoreItemPriceChangesWindowOpensTimeOfDayView : '00:00';
    this.schedule.meatStoreItemPriceChangesWindowClosesTimeOfDay = this.schedule.meatStoreItemPriceChangesWindowClosesTimeOfDayView != null ? this.schedule.meatStoreItemPriceChangesWindowClosesTimeOfDayView : '00:00';

    this.schedule.produceStoreItemPriceChangesWindowOpensTimeOfDay = this.schedule.produceStoreItemPriceChangesWindowOpensTimeOfDayView != null ? this.schedule.produceStoreItemPriceChangesWindowOpensTimeOfDayView : '00:00';
    this.schedule.produceStoreItemPriceChangesWindowClosesTimeOfDay = this.schedule.produceStoreItemPriceChangesWindowClosesTimeOfDayView != null ? this.schedule.produceStoreItemPriceChangesWindowClosesTimeOfDayView : '00:00';

    this.schedule.nowChangesLockoutWindowOpensTimeOfDay = this.schedule.nowChangesLockoutWindowOpensTimeOfDayView != null ? this.schedule.nowChangesLockoutWindowOpensTimeOfDayView : '00:00';
    this.schedule.nowChangesLockoutWindowClosesTimeOfDay = this.schedule.nowChangesLockoutWindowClosesTimeOfDayView != null ? this.schedule.nowChangesLockoutWindowClosesTimeOfDayView : '00:00';

    this.schedule.serverMaintenanceWindowOpensTimeOfDay = this.schedule.serverMaintenanceWindowOpensTimeOfDayView != null ? this.schedule.serverMaintenanceWindowOpensTimeOfDayView : '00:00';
    this.schedule.serverMaintenanceWindowClosesTimeOfDay = this.schedule.serverMaintenanceWindowClosesTimeOfDayView != null ? this.schedule.serverMaintenanceWindowClosesTimeOfDayView : '00:00';

    this.schedule.updateStoreItemsFromPreviewStoreItemsTimeOfDay = this.schedule.updateStoreItemsFromPreviewStoreItemsTimeOfDayView != null ? this.schedule.updateStoreItemsFromPreviewStoreItemsTimeOfDayView : '00:00';
    this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsTimeOfDay = this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsTimeOfDayView != null ? this.schedule.updateStoreItemsFromMeatAndProducePreviewStoreItemsTimeOfDayView : '00:00';
    this.schedule.deleteMeatAndProducePreviewStoreItemsTimeOfDay = this.schedule.deleteMeatAndProducePreviewStoreItemsTimeOfDayView != null ? this.schedule.deleteMeatAndProducePreviewStoreItemsTimeOfDayView : '00:00';
    this.schedule.incrementStoreItemsWeeksInStoreTimeOfDay = this.schedule.incrementStoreItemsWeeksInStoreTimeOfDayView != null ? this.schedule.incrementStoreItemsWeeksInStoreTimeOfDayView : '00:00';
    this.schedule.resetStoreItemsMovementAndWeeksInStoreTimeOfDay = this.schedule.resetStoreItemsMovementAndWeeksInStoreTimeOfDayView != null ? this.schedule.resetStoreItemsMovementAndWeeksInStoreTimeOfDayView : '00:00';
    this.schedule.purgeOldLogActionsTimeOfDay = this.schedule.purgeOldLogActionsTimeOfDayView != null ? this.schedule.purgeOldLogActionsTimeOfDayView : '00:00';
    this.schedule.purgeOldMessagesTimeOfDay = this.schedule.purgeOldMessagesTimeOfDayView != null ? this.schedule.purgeOldMessagesTimeOfDayView : '00:00';
    this.schedule.purgeOldAdItemsTimeOfDay = this.schedule.purgeOldAdItemsTimeOfDayView != null ? this.schedule.purgeOldAdItemsTimeOfDayView : '00:00';
    this.schedule.purgeOldStoreItemPriceChangesTimeOfDay = this.schedule.purgeOldStoreItemPriceChangesTimeOfDayView != null ? this.schedule.purgeOldStoreItemPriceChangesTimeOfDayView : '00:00';
    this.schedule.purgeOldStoreItemCostChangesTimeOfDay = this.schedule.purgeOldStoreItemCostChangesTimeOfDayView != null ? this.schedule.purgeOldStoreItemCostChangesTimeOfDayView : '00:00';
    this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChangesTimeOfDay = this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChangesTimeOfDayView != null ? this.schedule.purgeOldDenormalizedPreviewStoreItemPriceChangesTimeOfDayView : '00:00';

    this._scheduleService.updateSchedule(this.schedule)
      .subscribe(
        (data) => {
          this._messageService.onSuccess('Successfully updated schedule');
          this.getSchedule();
        },
        (response) => {
          this._messageService.onFailure('Failed to update schedule.', response);
        }
      )
  };

  onBackwardOneDay = function (eventAsString) {
    //Users with hasReadOnlyRestriction set to true should not even be allowed to invoke this action because it is hidden or disabled in the UI.
    //This is for extra protection. The back end will also be protected.
    if (this.myUser.hasReadOnlyRestriction){
      this._messageService.alertReadOnlyRestriction();
      return;
    }
    
    this._scheduleService.setDailyScheduledEventBackwardOneDay(eventAsString)
      .subscribe(
        (data) => {
          this._messageService.onSuccess('Successfully updated schedule');
          this.getSchedule();
        },
        (response) => {
          this._messageService.onFailure('Failed to set scheduled event backward one day.', response);
        }
      )
  };

  onForwardOneDay = function (eventAsString) {
    //Users with hasReadOnlyRestriction set to true should not even be allowed to invoke this action because it is hidden or disabled in the UI.
    //This is for extra protection. The back end will also be protected.
    if (this.myUser.hasReadOnlyRestriction){
      this._messageService.alertReadOnlyRestriction();
      return;
    }

    this._scheduleService.setDailyScheduledEventForwardOneDay(eventAsString)
      .subscribe(
        (data) => {
          this._messageService.onSuccess('Successfully updated schedule');
          this.getSchedule();
        },
        (response) => {
          this._messageService.onFailure('Failed to set scheduled event forward one day.', response);
        }
      )
  };

  onBackwardOneWeek = function (eventAsString) {
    //Users with hasReadOnlyRestriction set to true should not even be allowed to invoke this action because it is hidden or disabled in the UI.
    //This is for extra protection. The back end will also be protected.
    if (this.myUser.hasReadOnlyRestriction){
      this._messageService.alertReadOnlyRestriction();
      return;
    }

    this._scheduleService.setWeeklyScheduledEventBackwardOneWeek(eventAsString)
      .subscribe(
        (data) => {
          this._messageService.onSuccess('Successfully updated schedule');
          this.getSchedule();
        },
        (response) => {
          this._messageService.onFailure('Failed to set scheduled event backward one week.', response);
        }
      )
  };

  onForwardOneWeek = function (eventAsString) {
    //Users with hasReadOnlyRestriction set to true should not even be allowed to invoke this action because it is hidden or disabled in the UI.
    //This is for extra protection. The back end will also be protected.
    if (this.myUser.hasReadOnlyRestriction){
      this._messageService.alertReadOnlyRestriction();
      return;
    }

    this._scheduleService.setWeeklyScheduledEventForwardOneWeek(eventAsString)
      .subscribe(
        (data) => {
          this._messageService.onSuccess('Successfully updated schedule');
          this.getSchedule();
        },
        (response) => {
          this._messageService.onFailure('Failed to set scheduled event forward one week.', response);
        }
      )
  };

  onBackwardOneYear = function (eventAsString) {
    //Users with hasReadOnlyRestriction set to true should not even be allowed to invoke this action because it is hidden or disabled in the UI.
    //This is for extra protection. The back end will also be protected.
    if (this.myUser.hasReadOnlyRestriction){
      this._messageService.alertReadOnlyRestriction();
      return;
    }

    this._scheduleService.setYearlyScheduledEventBackwardOneYear(eventAsString)
      .subscribe(
        (data) => {
          this._messageService.onSuccess('Successfully updated schedule');
          this.getSchedule();
        },
        (response) => {
          this._messageService.onFailure('Failed to set scheduled event backward one year', response);
        }
      )
  };

  onForwardOneYear = function (eventAsString) {
    //Users with hasReadOnlyRestriction set to true should not even be allowed to invoke this action because it is hidden or disabled in the UI.
    //This is for extra protection. The back end will also be protected.
    if (this.myUser.hasReadOnlyRestriction){
      this._messageService.alertReadOnlyRestriction();
      return;
    }

    this._scheduleService.setYearlyScheduledEventForwardOneYear(eventAsString)
      .subscribe(
        (data) => {
          this._messageService.onSuccess('Successfully updated schedule');
          this.getSchedule();
        },
        (response) => {
          this._messageService.onFailure('Failed to set scheduled event forward one year.', response);
        }
      )
  };

  // initSignalR(){
  //   var self = this;

  //   // Reference the auto-generated proxy for the hub
  //   this.priceManagementHub = $.connection.priceManagement;

  //   this.priceManagementHub.client.serverMaintenanceEnabledStateChange = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.previewStoreItemPriceChangesEnabledStateChange = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.meatAndProducePreviewStoreItemPriceChangesEnabledStateChange = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.storeItemPriceChangesEnabledStateChange = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.meatAndProduceStoreItemPriceChangesEnabledStateChange = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.deletingMeatAndProducePreviewStoreItems = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.incrementingWeeksInStore = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.purgingOldLogActions = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.purgingOldMessages = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.purgingOldAdItems = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.purgingOldStoreItemPriceChanges = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.purgingOldStoreItemCostChanges = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };
  
  //   this.priceManagementHub.client.processingPricingRules = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.resettingMovementAndWeeksInStore = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.updatingStoreItemsFromMeatAndProducePreviewStoreItems = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.updatingStoreItemsFromPreviewStoreItems = function (data) {
  //     //console.log(data);
  //     self._messageService.showToastBottomLeft(data.reason);
  //     self.getSchedule();
  //   };

  //   this.priceManagementHub.client.scheduleEvent = function (event, reason) {
  //     console.log('scheduleEvent called for event: ' + event + ' with reason: ' + reason);
  //     self._messageService.showToastBottomLeft(reason);
  //     self.getSchedule();
  //   };

  //   // Optionally turn on client side logging
  //   $.connection.hub.logging = true;

  //   // Set the connection URL
  //   $.connection.hub.url = AppConfig.settings.baseUrl + '/signalr';

  //   // Append the bearer token to the query string
  //   var token = sessionStorage.getItem('rpmsToken');
  //   $.connection.hub.qs = { 'access_token': token };

  //   // Optionally wire up an error handler
  //   $.connection.hub.error(function (error) {
  //     console.log('SignalR error: ' + error);
  //   });

  //   var tryingToReconnect = false;
  //   var counter = 1;

  //   $.connection.hub.connectionSlow(function () {
  //     console.log("SignalR connection is slow.");
  //   });

  //   $.connection.hub.reconnecting(function () {
  //     tryingToReconnect = true;
  //     console.log("Trying to reconnect to SignalR.");
  //   });

  //   $.connection.hub.reconnected(function () {
  //     tryingToReconnect = false;
  //     console.log("SignalR has reconnected.");
  //   });

  //   $.connection.hub.disconnected(function () {
  //     console.log(counter);
  //     if (tryingToReconnect) {
  //       console.log("Could not connect to SignalR.");
  //     }
  //     if (counter <= 24) {
  //       self.signalRTimeout = setTimeout(function () {
  //         $.connection.hub.start().done(function () {
  //           console.log("SignalR hub has started again.");
  //         });
  //       }, 5000);
  //       counter++;
  //     }
  //     else {
  //       self._messageService.alert("Could not connect to the server. Please close the browser window and try to log back in to continue using the application.");
  //     }
  //   });

  //   // Start the connection
  //   $.connection.hub.start().done(function () {
  //     console.log('SignalR hub has started.');
  //   });
    
  // }

    // $scope.$on("$stateChangeStart", function (e, toState) {
    //   $.connection.hub.stop();
    //   console.log('SignalR was stopped.');
    // });


}
